<template>
  <div class="page">
    <div>
      <Panel
        lineColor="var(--primary-color)"
        style="margin-bottom: 0px; display: flex;"
      >
        <h3 class="text-uppercase my-5">Painel Administrativo</h3>
      </Panel>
    </div>
  </div>
</template>

<script>
import Panel from "@/components/Panel";

export default {
  name: "InicioAdmin",
  components: {
    Panel
  },
  data: () => ({}),
  methods: {}
};
</script>
